import BigNumber from 'bignumber.js/bignumber'

import compound from '../../assets/img/icon1.png'
import aave from '../../assets/img/aave.png'
import curve from '../../assets/img/curve.png'
import Yearn from '../../assets/img/Yearn.png'
import balancer from '../../assets/img/balancer.png'
import sushiswap from '../../assets/img/sushiswap.png'
import nexus_mutual from '../../assets/img/nexus_mutual.png'
import pickle from '../../assets/img/pickle.png'
import keeper_dAO from '../../assets/img/keeper_dAO.png'
import boring_DAO from '../../assets/img/boring_DAO.png'
import {AppConfig} from "../../config";

export const SUBTRACT_GAS_LIMIT = 100000;

const ONE_MINUTE_IN_SECONDS = new BigNumber(60);
const ONE_HOUR_IN_SECONDS = ONE_MINUTE_IN_SECONDS.times(60);
const ONE_DAY_IN_SECONDS = ONE_HOUR_IN_SECONDS.times(24);
const ONE_YEAR_IN_SECONDS = ONE_DAY_IN_SECONDS.times(365);





export const supportedPools = [
    {
        lpAddresses: {
            1: '0x20945cA1df56D237fD40036d47E866C7DcCD2114',
            42: '0x7FAE2E2A9d06398b3b116fA301519dC5f41FbD9B'
        },
        contractAddresses: {
            1: '0xB74f04D6577Ef1D10Ac350aecB178100A107E28d',
            42: '0x927164bE3A85652394D2A4Ff061EA2A340e7A1D9',
        },
        name: 'Compound',
        symbol: 'compound',
        tokenSymbol: 'compound',
        icon: compound,
        vesting:"180",
        tsl:AppConfig.allTsl.compound,
    },
    {
        lpAddresses: {
            1: '0x20945cA1df56D237fD40036d47E866C7DcCD2114',
            42: '0x7FAE2E2A9d06398b3b116fA301519dC5f41FbD9B'
        },
        contractAddresses: {
            1: '0xc510ccb5122fBAB3510dEc9Cdf2e3caCb91c2F4a',
            42: '0xcEaDc622a6D6085A1fb086C09880b622A4676a93',
        },
        name: 'Aave',
        symbol: 'aave',
        tokenSymbol: 'aave',
        icon: aave,
        vesting:"14 Days",
        tsl:AppConfig.allTsl.aave,

    },
    {
        lpAddresses: {
            1: '0x20945cA1df56D237fD40036d47E866C7DcCD2114',
            42: '0x7FAE2E2A9d06398b3b116fA301519dC5f41FbD9B'
        },
        contractAddresses: {
            1: '0xde54079fb8c1a6aaed9d3c644be74b5d110f2c6c',
            42: '0x9A007aB69e3382d89dF126cBaB98d3E6e24C884a',
        },
        name: 'Curve Finance',
        symbol: 'curve',
        tokenSymbol: 'c',
        icon: curve,
        vesting:"14 Days",
        tsl:AppConfig.allTsl.curve,

    },
    {
        lpAddresses: {
            1: '0x20945cA1df56D237fD40036d47E866C7DcCD2114',
            42: '0x7FAE2E2A9d06398b3b116fA301519dC5f41FbD9B'
        },
        contractAddresses: {
            1: '0x9aEf1913638A79e2BDa918fe75e64507bAEf2ed7',
            42: '0x9A007aB69e3382d89dF126cBaB98d3E6e24C884a',
        },
        name: 'Sushiswap',
        symbol: 'sushiswap',
        tokenSymbol: 'f',
        icon: sushiswap,
        vesting:"14 Days",
        tsl:AppConfig.allTsl.sushiswap,

    },
    {
        lpAddresses: {
            1: '0x20945cA1df56D237fD40036d47E866C7DcCD2114',
            42: '0x7FAE2E2A9d06398b3b116fA301519dC5f41FbD9B'
        },
        contractAddresses: {
            1: '0xd3d7a6fb93aca807b5c208cce4f6b203f944a158',
            42: '0x9A007aB69e3382d89dF126cBaB98d3E6e24C884a',
        },
        name: 'Yearn Finance',
        symbol: 'yearn',
        tokenSymbol: 'd',
        icon: Yearn,
        vesting:"14 Days",
        tsl:AppConfig.allTsl.yearn,

    },
    {
        lpAddresses: {
            1: '0x20945cA1df56D237fD40036d47E866C7DcCD2114',
            42: '0x7FAE2E2A9d06398b3b116fA301519dC5f41FbD9B'
        },
        contractAddresses: {
            1: '0x6247b983a2a523664b0abf04e62f4156210f0ca1',
            42: '0x9A007aB69e3382d89dF126cBaB98d3E6e24C884a',
        },
        name: 'Balancer',
        symbol: 'balancer',
        tokenSymbol: 'e',
        icon: balancer,
        vesting:"14 Days",
        tsl:AppConfig.allTsl.balancer,

    },
    {
        lpAddresses: {
            1: '0x20945cA1df56D237fD40036d47E866C7DcCD2114',
            42: '0x7FAE2E2A9d06398b3b116fA301519dC5f41FbD9B'
        },
        contractAddresses: {
            1: '0x7ECE31a0D6f3aB15ED0F2B7C865fC14187960194',
            42: '0x9A007aB69e3382d89dF126cBaB98d3E6e24C884a',
        },
        name: 'Nexus Mutual',
        symbol: 'nexusMutual',
        tokenSymbol: 'g',
        icon: nexus_mutual,
        vesting:"14 Days",
        tsl:AppConfig.allTsl.nexusMutual,

    },
    {
        lpAddresses: {
            1: '0x20945cA1df56D237fD40036d47E866C7DcCD2114',
            42: '0x7FAE2E2A9d06398b3b116fA301519dC5f41FbD9B'
        },
        contractAddresses: {
            1: '0xFBfbBAf115435Bc60e77114e2C0750A483Cd970b',
            42: '0x9A007aB69e3382d89dF126cBaB98d3E6e24C884a',
        },
        name: 'Pickle',
        symbol: 'pickle',
        tokenSymbol: 'h',
        icon: pickle,
        vesting:"14 Days",
        tsl:AppConfig.allTsl.pickle,

    },
    {
        lpAddresses: {
            1: '0x20945cA1df56D237fD40036d47E866C7DcCD2114',
            42: '0x7FAE2E2A9d06398b3b116fA301519dC5f41FbD9B'
        },
        contractAddresses: {
            1: '0x3f1cbbd8e899e67349f7344b3f21abf6a55727d7',
            42: '0x9A007aB69e3382d89dF126cBaB98d3E6e24C884a',
        },
        name: 'KeeperDAO',
        symbol: 'keeperDAO',
        tokenSymbol: 'i',
        icon: keeper_dAO,
        vesting:"14 Days",
        tsl:AppConfig.allTsl.keeperDAO,

    },
    {
        lpAddresses: {
            1: '0x20945cA1df56D237fD40036d47E866C7DcCD2114',
            42: '0x7FAE2E2A9d06398b3b116fA301519dC5f41FbD9B'
        },
        contractAddresses: {
            1: '0xab7900bea67a6eaf03719c40c8e87020d79a8b42',
            42: '0x9A007aB69e3382d89dF126cBaB98d3E6e24C884a',
        },
        name: 'BoringDAO',
        symbol: 'boringDAO',
        tokenSymbol: 'j',
        icon: boring_DAO,
        vesting:"14 Days",
        tsl:AppConfig.allTsl.boringDAO,

    },
];


/*export const contractAddresses = {
    // sushi: {
    //     1: '0x6b3595068778dd592e39a122f4f5a5cf09c90fe2',
    // },
    // masterChef: {
    //     1: '0xc2edad668740f1aa35e4d8f227fb8e17dca888cd',
    // },
    // weth: {
    //     1: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
    // },
    stakIng: {
        42: '0xA8a3dCab5d6A939CCB4D6EF0c306BDb5b554F3D6',
    }
};*/


